import type { AssistantToolErrorShape } from '@/features/assistant/tool-errors'

export const LOCAL_AGENT_PROTOCOL_VERSION = '2026-06-20'

export type LocalAgentLifecycleEventType =
  | 'app-ready'
  | 'workspace-ready'
  | 'current-project-changed'

export interface LocalAgentBridgeRequest {
  requestId: string
  toolName: string
  input?: Record<string, unknown>
  sessionId?: string
  protocolVersion: string
}

export interface LocalAgentBridgeCancelRequest {
  requestId: string
  reason?: string
  protocolVersion: string
}

export interface LocalAgentBridgeProgressPayload {
  requestId: string
  toolName: string
  stage?: 'starting' | 'running' | 'completed' | 'failed' | 'cancelled'
  progressPercent?: number
  progressLabel?: string | null
  supportsCancellation?: boolean
  detail?: unknown
  protocolVersion: string
}

export interface LocalAgentSamplingTextContent {
  type: 'text'
  text: string
}

export interface LocalAgentSamplingMessage {
  role: 'user' | 'assistant' | 'system'
  content: LocalAgentSamplingTextContent[]
}

export interface LocalAgentSamplingRequest {
  requestId: string
  messages: LocalAgentSamplingMessage[]
  systemPrompt?: string
  temperature?: number
  maxTokens?: number
  protocolVersion: string
}

export interface LocalAgentSamplingSuccessResponse {
  requestId: string
  ok: true
  result: {
    role: 'assistant'
    content: LocalAgentSamplingTextContent[]
  }
  protocolVersion: string
}

export interface LocalAgentSamplingErrorResponse {
  requestId: string
  ok: false
  error: AssistantToolErrorShape
  protocolVersion: string
}

export type LocalAgentSamplingResponse =
  | LocalAgentSamplingSuccessResponse
  | LocalAgentSamplingErrorResponse

export interface LocalAgentBridgeSuccessResponse {
  requestId: string
  toolName: string
  ok: true
  result: unknown
  protocolVersion: string
}

export interface LocalAgentBridgeErrorResponse {
  requestId: string
  toolName: string
  ok: false
  error: AssistantToolErrorShape
  protocolVersion: string
}

export type LocalAgentBridgeResponse =
  | LocalAgentBridgeSuccessResponse
  | LocalAgentBridgeErrorResponse

export interface LocalAgentBridgeLifecyclePayload {
  type: LocalAgentLifecycleEventType
  currentProjectId: string | null
  currentWorkspaceName: string | null
  currentEditorWorkspace: string | null
  isUserSignedIn: boolean
  subscriptionTier: string | null
  protocolVersion: string
}
